import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-[#0a192f] text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-pink-600">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p>
            Embrace the future of software with Me, Elevate your digital journey to unparalleled heights.
            </p>
          </div>
          <div>
            <p>
              Unlocking the boundless power of code, I fuel my passion for
              crafting exceptional software that ignites positive change in the
              lives of others. From visionary individuals to dynamic
              small-businesses, and mighty enterprise giants, I wield my
              expertise to forge software solutions that shape the future. With
              me as your digital sorcerer, the realm of limitless possibilities
              in software awaits at your fingertips, ready to manifest your
              boldest dreams into reality.F?
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
